/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const RightArrowDropdownItem = styled.span({
  display: 'flex',
  width: '280px',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const BadgeChevronWrapper = styled.span({
  display: 'flex',
  alignItems: 'center',
});
